import { render, staticRenderFns } from "./new-batch-button.vue?vue&type=template&id=cac7d9a4&"
import script from "./new-batch-button.vue?vue&type=script&lang=js&"
export * from "./new-batch-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports